export const appConfig = {
  chatURL: 'https://stable.web.cai.demo.sestek.com/webchat',
  kibanaURL: 'http://kibana.cai.sestek.localdev',
};
